import React, { useEffect } from 'react'
import { Modal } from '../Modal'
import { PDFViewer } from '../../organisms/PDFViewer/PDFViewer'
import {
  PreviewContainer,
  PreviewHeader,
  FileName,
  PreviewBody,
  ImagePreview,
} from './FilePreviewModal.styles'

export interface FilePreviewModalProps {
  isOpen: boolean
  onClose: () => void
  fileUrl: string
  fileName: string
  fileType: 'pdf' | 'image'
}

export const FilePreviewModal: React.FC<FilePreviewModalProps> = ({
  isOpen,
  onClose,
  fileUrl,
  fileName,
  fileType,
}) => {
  // Revoke blob URL on close
  useEffect(() => {
    return () => {
      if (fileUrl && fileUrl.startsWith('blob:')) {
        window.URL.revokeObjectURL(fileUrl)
      }
    }
  }, [fileUrl])

  const handleClose = () => {
    if (fileUrl && fileUrl.startsWith('blob:')) {
      window.URL.revokeObjectURL(fileUrl)
    }
    onClose()
  }

  return (
    <Modal isOpen={isOpen} onClose={handleClose} fullScreen>
      <PreviewContainer>
        <PreviewHeader>
          <FileName title={fileName}>{fileName}</FileName>
        </PreviewHeader>
        <PreviewBody>
          {fileType === 'pdf' ? (
            <PDFViewer url={fileUrl} enableDownload={false} />
          ) : (
            <ImagePreview src={fileUrl} alt={fileName} />
          )}
        </PreviewBody>
      </PreviewContainer>
    </Modal>
  )
}
